import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 items-start">
          {/* Logo + Contact */}
          <div className="lg:col-span-2">
            <div className="flex flex-col md:flex-row md:items-start md:space-x-12">
              {/* Logo Section */}
              <div className="text-center md:text-left mb-8 md:mb-0">
                <img
                  src="/DataCareSolutionsMainLogoCroped.png"
                  alt="Data Care Solutions Logo"
                  className="w-48 md:w-56 mx-auto md:mx-0 mb-6 bg-white/5 p-3 rounded-lg transition-transform duration-200 hover:scale-105"
                  loading="lazy"
                />
                <p className="text-gray-300 text-lg max-w-md mx-auto md:mx-0">
                  Custom dashboards, AI automation, and data pipelines
                  for teams that outgrew spreadsheets.
                </p>
              </div>

              {/* Contact Info */}
              <div className="text-center md:text-left">
                <h3 className="text-xl font-bold mb-6 text-white">Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-center md:justify-start">
                    <svg className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <a href="tel:+19286070710" className="text-gray-300 hover:text-white transition-colors duration-200">
                      (928) 607-0710
                    </a>
                  </div>
                  <div className="flex items-center justify-center md:justify-start">
                    <svg className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <a href="mailto:Admin@datacaresolutions.net" className="text-gray-300 hover:text-white transition-colors duration-200">
                      Admin@datacaresolutions.net
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-6 text-white">Quick Links</h3>
            <nav className="space-y-3">
              <a href="#home" className="block text-gray-300 hover:text-white transition-colors duration-200 hover:translate-x-1 transform">
                Home
              </a>
              <a href="#about" className="block text-gray-300 hover:text-white transition-colors duration-200 hover:translate-x-1 transform">
                About Us
              </a>
              <a href="#services" className="block text-gray-300 hover:text-white transition-colors duration-200 hover:translate-x-1 transform">
                Our Services
              </a>
              <a href="#contact" className="block text-gray-300 hover:text-white transition-colors duration-200 hover:translate-x-1 transform">
                Contact Us
              </a>
            </nav>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Data Care Solutions. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
